module.exports = __webpack_public_path__ + "static/media/seinfeld-nyc.446be1c2.png";